namespace TabAurous.ECommerce {
    export interface ECommRefundRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        Date?: string;
        RefNo?: string;
        RefDate?: string;
        EnteredBy?: string;
        LedgerId?: number;
        POSCustomerId?: number;
        LedgerName?: string;
        Mobile?: string;
        Email?: string;
        TotalAmount?: number;
        Narration?: string;
        Url?: string;
        PayOutId?: string;
        VoucherTypeId?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        RefundTotal?: number;
        ECommRefundDetails?: ECommRefundDetailsRow[];
        PartyBalance?: Finance.PartyBalanceRow[];
        OrderVoucherNo?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
        RefundECommsible?: number;
    }

    export namespace ECommRefundRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.ECommRefund';
        export const deletePermission = 'Retail:Refund:Delete';
        export const insertPermission = 'Retail:Refund:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:Refund:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            Date = "Date",
            RefNo = "RefNo",
            RefDate = "RefDate",
            EnteredBy = "EnteredBy",
            LedgerId = "LedgerId",
            POSCustomerId = "POSCustomerId",
            LedgerName = "LedgerName",
            Mobile = "Mobile",
            Email = "Email",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            Url = "Url",
            PayOutId = "PayOutId",
            VoucherTypeId = "VoucherTypeId",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            RefundTotal = "RefundTotal",
            ECommRefundDetails = "ECommRefundDetails",
            PartyBalance = "PartyBalance",
            OrderVoucherNo = "OrderVoucherNo",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate",
            RefundECommsible = "RefundECommsible"
        }
    }
}
